import React from 'react';
import { Menu, Bell, Search } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';
type TopBarProps = {
  onMenuClick: () => void;
};
export const TopBar: React.FC<TopBarProps> = ({
  onMenuClick
}) => {
  const {
    state
  } = useAppContext();
  const {
    user
  } = state;
  return <header className="h-16 bg-white border-b border-gray-100 flex items-center justify-between px-4 sm:px-6 lg:px-8 sticky top-0 z-30" data-id="element-219">
      <div className="flex items-center gap-4" data-id="element-220">
        <button onClick={onMenuClick} className="lg:hidden p-2 -ml-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-221">
          <Menu size={24} data-id="element-222" />
        </button>
        <h1 className="text-xl font-semibold text-brand-text-dark hidden sm:block" data-id="element-223">
          Welcome back, {user?.name.split(' ')[0]}
        </h1>
      </div>

      <div className="flex items-center gap-4" data-id="element-224">
        {/* Search */}
        <div className="hidden md:flex relative" data-id="element-225">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-226" />
          <input type="text" placeholder="Search transactions..." className="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary/20 focus:border-brand-primary w-64 transition-all" data-id="element-227" />
        </div>

        {/* Notifications */}
        <button className="relative p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-50 transition-colors" data-id="element-228">
          <Bell size={20} data-id="element-229" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-brand-error rounded-full border-2 border-white" data-id="element-230"></span>
        </button>
      </div>
    </header>;
};